export default class Dots {
  constructor() {
    this._dots = [];
    this._definitions = {};
  }

  add(dot) {
    this._dots.push(dot);
    this.addDotDefinition(dot);
  }

  addAtIndex(index, dot) {
    this._dots.splice(index, 0, dot);
    this.addDotDefinition(dot);
    if (typeof window !== 'undefined') {
      window.followmeMap.buildDotTable();
    }
  }

  popDotDefinitions() {
    let definitions = [];
    let dots = [];

    this._dots.forEach((dot) => {
      if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') {
        dots.push(dot);

        return;
      }

      definitions.push(dot.getEvent());
    });

    this._dots = dots;

    return definitions;
  }

  addDotDefinition(dot) {
    if (!dot.hasEvent() || dot.getEvent().constructor.name !== 'EventCustomDefinition') return;

    const eventCode = parseInt(dot.getEvent().getDefinition().code, 10);
    this._definitions[eventCode] = dot.getEvent();
  }

  getTotal() {
    return this._dots.length;
  }

  getTotalVisible() {
    return this._dots.filter((dot) => {
      return dot.isDrawable();
    }).length;
  }

  get() {
    return this._dots;
  }

  getByEventCustomDefinitionCode(code) {
    for (let i = 0; i < this._dots.length; i++) {
      if (this._dots[i].hasEvent() &&
        this._dots[i].getEvent().constructor.name === 'EventCustomDefinition' &&
        this._dots[i].getEvent().getDefinition().code === code
      ) {
        return this._dots[i];
      }
    }

    return null;
  }

  refreshDefinitions() {
    this._definitions = {};

    for (let i = 0; i < this._dots.length; i++) {
      if (this._dots[i].hasEvent() &&
        this._dots[i].getEvent().constructor.name === 'EventCustomDefinition'
      ) {
        const eventCode = parseInt(this._dots[i].getEvent().getDefinition().code, 10);
        this._definitions[eventCode] = this._dots[i].getEvent();
      }
    }
  }

  getDefinitions() {
    return this._definitions;
  }

  getByIndex(index) {
    return this._dots[index];
  }

  deleteDots(dotsIndexesToDelete) {
    this._dots = this._dots.filter((dot, index) => {
      return dotsIndexesToDelete.indexOf(index) === -1;
    });
  }

  replaceWith(dots) {
    this._dots = [];

    dots.forEach((dot) => {
      this._dots.push(dot);
    });
  }
}
module.exports = Dots;
